<template>
    <v-card class="my-2 car-card" variant="outlined">
        <v-img
            tile
            :src="$filters.imageUrl(mainImg, 600)"
            :alt="product.info.modelName"
            height="200"
            lazy-src="/placeholder.png"
            eager
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            class="text-white align-end"
        >
            <template v-slot:placeholder>
                <v-row
                    v-show="!imgError && product.info.imageUrl"
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                >
                    <v-progress-circular indeterminate color="grey-lighten-5" />
                </v-row>
            </template>
            <v-card-title>
                <div class="d-flex flex-column" :title="product.info.modelName">
                    <span class="text-subtitle-2">
                        {{ product.info.modelName }}
                        <ProductOfferTipsDialog
                            v-if="product.offer.tipsAvailable"
                            :offer-key="product.offer.offerKey"
                            activator-class="text-white"
                        />
                    </span>
                </div>
            </v-card-title>
        </v-img>
        <supplier-name-label v-if="isTO1" :supplier-name="product.info.supplierName" class="mb-1" />
        <slot name="summary" />
        <car-feature-labels :info="product.info" small class="mb-2" />
        <car-characteristic :info="product.info" />
        <div v-if="product.info.shortDescription" v-html="product.info.shortDescription" />
        <div v-if="!hideMap" class="cursor-pointer" @click="mapModal = true">
            <v-icon size="small" color="info">mdi-map-marker</v-icon>
            <span class="text-caption text-primary text-decoration-underline text-lowercase">
                {{ $t('show_on_map') }}
            </span>
        </div>
        <div class="wrap-words mt-1">
            <div v-if="product.offer.available" class="d-flex align-center text-caption">
                <v-icon :title="$t('available')" start size="small">mdi-checkbox-marked-circle</v-icon>
                <span class="text-success" v-text="$t('available')" />
            </div>
            <div v-else class="d-flex align-center text-caption">
                <v-icon :title="$t('on_request')" start size="small">mdi-alert-circle</v-icon>
                <span class="text-warning" v-text="$t('on_request')" />
            </div>
        </div>
        <span v-if="product.offer && product.offer.price" class="text-caption mt-1">
            <conditions-label
                :offer-key="product.offer.offerKey"
                :price="product.offer.price"
                @conditions="showConditionsInfo"
            />
        </span>
        <div class="d-flex align-center text-primary cursor-pointer text-no-wrap text-caption" @click="showOfferInfo">
            <v-icon size="small" start>mdi-information-outline</v-icon>
            <span class="show-description-label">
                {{ `${$t('show')} ${$t('description').toLowerCase()}` }}
            </span>
        </div>
        <feature-includes :features="product.info.features" class="mt-1" />
        <div v-if="!bookDisabled" class="d-flex justify-space-between align-center">
            <discount-label :price="product.offer.price" class="d-inline-block" />
            <div data-cy="client-price" class="font-weight-medium">
                {{ $filters.price(product.offer.price) }}
            </div>
            <v-btn v-if="!product.offer.soldOut" color="primary" variant="flat" class="my-2" @click="selectForBooking">
                {{ $t('book') }}
            </v-btn>
            <sold-out-modal v-else small />
        </div>
        <client-only v-if="!hideMap">
            <v-dialog v-model="mapModal" :max-width="600">
                <car-map-points
                    v-model="mapExpanded"
                    :pick-up-points="product.offer.pickUpPoints"
                    :return-points="product.offer.returnPoints"
                    :parent="true"
                    style="max-height: 500px; position: unset"
                />
            </v-dialog>
        </client-only>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {CarOfferCard} from '@/components/carsRent/search/offers/CarOfferCard.vue'

    @Component({})
    export class CarOfferCardMobile extends CarOfferCard {
        @Prop({default: false, type: Boolean}) bookDisabled
    }

    export default CarOfferCardMobile
</script>

<style lang="scss" scoped>
    .car-card {
        border: none !important;
    }
</style>
